import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FaEdit, FaTrashAlt } from 'react-icons/fa'
import { useSelector } from 'react-redux'
import 'react-toastify/dist/ReactToastify.css'

import { useGetAllFunctionsQuery } from '../../../api/services/functionsApi'
import { useGetCompanyGroupsPaginatedQuery } from '../../../api/services/groupsApi'
import { CreateCompanyGroupsModal, DeleteGroupModal, UpdateGroup } from '../../modals/modals'
import { Button } from '../../root/Button'
import NewTable from '../NewTable'

const TableGroups = () => {
  const { t } = useTranslation()
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(25)
  const [filterInputs, setFilterInputs] = useState({})

  const columns = useMemo(
    () => [
      {
        Header: 'ID',
        accessor: 'id',
      },
      {
        Header: t('name'),
        accessor: 'name',
      },
    ],
    [t],
  )

  const [open, setOpen] = useState(false)
  const [open2, setOpen2] = useState(false)
  const [group, setGroup] = useState()
  const [id, setId] = useState()
  const [newGroupName, setNewGroupName] = useState()
  const [newGroupFunctions, setNewGroupFunctions] = useState([])

  const [open3, setOpen3] = useState(false)

  const company = useSelector((state) => state.company.company)

  const query = useMemo(() => {
    let queryString = ''
    for (const [key, value] of Object.entries(filterInputs)) {
      if (value.trim() !== '') {
        queryString += `${key}=${encodeURIComponent(value)}&`
      }
    }

    return queryString.replace(/&$/, '')
  }, [filterInputs])

  const { data: paginatedGroups, isFetching, isLoading } = useGetCompanyGroupsPaginatedQuery(
    {
      companyId: company?.id,
      page,
      pageSize,
      query: query || '',
    },
    { skip: !company?.id },
  )

  const { data: allFunctions } = useGetAllFunctionsQuery()

  const tableHooksArray = [
    {
      label: t('edit'),
      Icon: FaEdit,
      onClick: (row) => {
        setOpen(true)
        setId(row.original.id)
        setGroup(row.original)
        setNewGroupName(row.original.name)
        setNewGroupFunctions(row.original.functions)
      },
      disabled: false,
    },
    {
      label: t('delete'),
      Icon: FaTrashAlt,
      onClick: (row) => {
        setOpen2(true)
        setId(row.original.id)
      },
      disabled: false,
    },
  ]

  const data = useMemo(
    () => (Array.isArray(paginatedGroups?.groups) ? paginatedGroups.groups : []),
    [paginatedGroups],
  )

  return (
    <div className="wrapper phone:hidden mt-2 flex flex-col gap-4">
      <div className="w-full flex justify-start">
        <div className="w-full max-w-xs">
          <Button onClick={() => setOpen3(true)}>{t('create_group')}</Button>
        </div>
      </div>

      <NewTable
        data={data}
        columns={columns}
        actions
        filtering
        hooksArray={tableHooksArray}
        hiddenColumns={['address']}
        setPage={setPage}
        pageManual={page}
        pageSize={pageSize}
        setPageAmount={setPageSize}
        controlledPageCount={paginatedGroups?.totalPages || 0}
        filterInputs={filterInputs}
        setFilterInputs={setFilterInputs}
        count={paginatedGroups?.totalCount}
        isFetching={isFetching}
        isLoading={isLoading}
      />

      <UpdateGroup
        setNewGroupFunctions={setNewGroupFunctions}
        newGroupFunctions={newGroupFunctions}
        setNewGroupName={setNewGroupName}
        groupFunctions={allFunctions}
        onClose={() => setOpen(false)}
        newGroupName={newGroupName}
        group={group}
        open={open}
        id={id}
      />
      <DeleteGroupModal onClose={() => setOpen2(false)} open={open2} id={id} />
      <CreateCompanyGroupsModal
        onClose={() => {
          setOpen3(false)
        }}
        open={open3}
      />
    </div>
  )
}
export default TableGroups
